"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Reward_1 = __importDefault(require("../../../Icons/Notifications/Reward"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var utils_1 = require("../../utils");
var NotificationItemNFTLink_1 = __importDefault(require("../../NotificationItemNFTLink"));
var config_1 = require("../../../../config");
var i18N = {
    en: {
        description: function (reward) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "You\u2019ve received a",
            react_1.default.createElement(NotificationItemNFTLink_1.default, { rarity: reward.tokenRarity, name: reward.tokenName, link: config_1.config.get('EXPLORER_URL') }),
            "for free. Try it out once it arrives!")); },
        title: 'A Gift is on its way!'
    },
    es: {
        description: function (reward) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Recibiste un",
            react_1.default.createElement(NotificationItemNFTLink_1.default, { rarity: reward.tokenRarity, name: reward.tokenName, link: config_1.config.get('EXPLORER_URL') }),
            "gratis. \u00A1Pruebalo cuando llegue!")); },
        title: '¡Un regalo está en camino!'
    },
    zh: {
        description: function (reward) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u60A8\u5DF2\u514D\u8D39\u6536\u5230\u4E00\u4E2A",
            react_1.default.createElement(NotificationItemNFTLink_1.default, { rarity: reward.tokenRarity, name: reward.tokenName, link: config_1.config.get('EXPLORER_URL') }),
            "\u3002\u4E00\u65E6\u5230\u8FBE\uFF0C\u7ACB\u5373\u8BD5\u8BD5\u5427\uFF01")); },
        title: '一份礼物正在路上！'
    }
};
function RewardInProgressNotification(_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: {
            image: notification.metadata.tokenImage,
            backgroundColor: (0, utils_1.getBGColorByRarity)(notification.metadata.tokenRarity),
            icon: react_1.default.createElement(Reward_1.default, null)
        }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata))));
}
exports.default = RewardInProgressNotification;
